import Chip from "@mui/material/Chip";
import Box from "@mui/material/Box";
import { HACK_alignIconWithLabel } from "@privacy/ui";
import { useTranslation } from "@privacy/translations";
import { useCurrentOrganisation } from "../../root/CurrentOrganisationProvider";

export const NewChip = () => {
  const { t } = useTranslation();
  return (
    <Chip
      label={t("InformationType.Sidebar.NewChip")}
      size="small"
      sx={{
        "height": 18,
        "borderRadius": 1,
        "fontSize": theme => theme.typography.pxToRem(11),
        "fontWeight": 600,
        "letterSpacing": "0.3px",
        "bgcolor": theme => theme.palette.primary["100"],
        "color": theme => theme.palette.primary["700"],
        "& .MuiChip-label": { px: 1.25, ...HACK_alignIconWithLabel },
      }}
    />
  );
};

export const InformationTypesUpsellChip = () => (useCurrentOrganisation().classificationEnabled ? null : <NewChip />);

export const InformationTypesUpsellDot = () =>
  useCurrentOrganisation().classificationEnabled ? null : (
    <Box
      aria-hidden
      sx={{
        "position": "absolute",
        "top": -2,
        "right": -2,
        "width": 8,
        "height": 8,
        "borderRadius": "50%",
        "bgcolor": theme => theme.palette.primary["600"],
        "border": theme => `1px solid ${theme.palette.grey["100"]}`,
        "@keyframes informationTypesUpsellDotPop": {
          "0%": { opacity: 0, transform: "scale(0.5)" },
          "60%": { opacity: 1, transform: "scale(1.15)" },
          "100%": { opacity: 1, transform: "scale(1)" },
        },
        "animation": "informationTypesUpsellDotPop 250ms cubic-bezier(0.23, 1, 0.32, 1) both",
      }}
    />
  );
